import { createFileRoute } from "@tanstack/react-router";
import JobPostingPage from "#/features/job-posting/JobPostingPage";
import { loadJobPostingPageData } from "#/features/job-posting/job-posting.functions";
import { metadataToHead, type PageMetadata } from "#/lib/seo";

const fallbackMetadata: PageMetadata = {
  description: "Roamdoc",
  metadataBase: "https://www.roamdoc.com",
  title: "Roamdoc",
};

export const Route = createFileRoute("/job/$slugWithIdentifier")({
  loader: ({ params }) =>
    loadJobPostingPageData({
      data: {
        slugWithIdentifier: params.slugWithIdentifier,
      },
    }),
  head: ({ loaderData }) => metadataToHead(loaderData?.metadata ?? fallbackMetadata),
  component: RouteComponent,
});

function RouteComponent() {
  const data = Route.useLoaderData();

  return <JobPostingPage data={data} />;
}
